import React from "react";

function ShopStage({ children }) {
  return <div className="shopStage">{children}</div>;
}

export default ShopStage;
